import { DataModel } from "@toolpad/core/Crud";

import { GroupType, IGroupInfoDto } from "../generated/api-client";
import { enumToValueOptions, nameof } from "../utils/object.utils";
import MagicCrud, { MagicCrudFields } from "../components/MagicCrud";

type GroupInfoDtoDataModel = IGroupInfoDto & DataModel;

export default function GroupsPage() {
  const columns: MagicCrudFields<IGroupInfoDto>[] = [
    {
      field: nameof<IGroupInfoDto>("id"),
      type: "number",
      extraType: "guid",
    },
    {
      field: nameof<IGroupInfoDto>("name"),
      type: "string",
    },
    {
      field: nameof<IGroupInfoDto>("type"),
      type: "singleSelect",
      valueOptions: enumToValueOptions(GroupType),
    },
    {
      field: nameof<IGroupInfoDto>("numberOfUsers"),
      type: "number",
      editable: false,
    },
    {
      field: nameof<IGroupInfoDto>("numberOfVehicles"),
      type: "number",
      editable: false,
    },
    {
      field: nameof<IGroupInfoDto>("updateDate"),
      type: "dateTime",
      editable: false,
    },
  ];

  return (
    <MagicCrud<GroupInfoDtoDataModel>
      name="group"
      apiUrl="groups"
      columns={columns}
      appUrl="/groups"
      disable={{ create: true, edit: true, delete: true, show: true }}
    />
  );
}
